import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import { ListCollaborationsResponse, UserRole } from '@inversor-hub/types';

export function useListCollaborations<R extends UserRole>(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['collaborations'],
    queryFn: async () => {
      const { data } = await apiClient.get<ListCollaborationsResponse<R>>('/collaborations');
      return data.data;
    },
    enabled: options?.enabled,
  });
}

export const useSignCollaboration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, role }: { id: string; role: 'investor' | 'psi' }) => {
      const res = await apiClient.post(`/collaborations/${id}/sign`, { role });
      return res.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['collaborations'] });
      queryClient.invalidateQueries({ queryKey: ['collaboration-contract', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['opportunities'] });
    },
  });
};
export const useGetCollaborationContract = (id?: string, enabled = true) => {
  return useQuery({
    queryKey: ['collaboration-contract', id],
    queryFn: async () => {
      const res = await apiClient.get<{ data: { url: string } }>(
        `/collaborations/${id}/contract/url`
      );
      return res.data.data;
    },
    enabled: !!id && enabled,
  });
};
